/**
 * <product-tile> — Embeddable product card for blog articles.
 * Matches the theme's native product-card design.
 *
 * Usage in article body_html:
 *   <product-tile handle="product-handle">
 *     <a href="/products/product-handle">Product Name</a>
 *   </product-tile>
 *
 * The inner <a> is the SEO fallback — crawlers see it immediately.
 * JavaScript replaces it with a rich card matching the theme style.
 */
(function () {
  if (!document.getElementById('product-tile-styles')) {
    var s = document.createElement('style');
    s.id = 'product-tile-styles';
    s.textContent = [
      'product-tile{display:block;margin:8px 0 48px;max-width:280px}',
      'product-tile .pt-card{display:block;background:#fff;border-radius:12px;text-decoration:none;color:inherit;overflow:hidden;box-shadow:0 1px 4px rgba(0,0,0,.06);transition:box-shadow .25s;line-height:0}',
      'product-tile .pt-card:hover{box-shadow:0 4px 20px rgba(0,0,0,.1)}',
      'product-tile .pt-media{position:relative;width:100%;aspect-ratio:1/1;overflow:hidden}',
      'product-tile .pt-media img{display:block;width:100%;height:100%;object-fit:cover;margin:0;padding:0;border-radius:0}',
      'product-tile .pt-info{padding:16px 18px 20px;line-height:1.4}',
      'product-tile .pt-vendor{margin:0 0 6px;font-size:.8em;text-transform:uppercase;letter-spacing:.8px;color:#999;font-weight:400}',
      'product-tile .pt-title{margin:0 0 14px;font-size:1.05em;font-weight:600;line-height:1.35;color:#1a1a1a}',
      'product-tile .pt-btn{display:inline-block;padding:10px 24px;background:#1a1a1a;color:#fff;font-size:.85em;font-weight:600;letter-spacing:.3px;border-radius:6px;transition:background .2s}',
      'product-tile .pt-card:hover .pt-btn{background:#333}',
      '@media(max-width:600px){product-tile{max-width:100%}}'
    ].join('');
    document.head.appendChild(s);
  }

  function esc(t) {
    var d = document.createElement('div');
    d.textContent = t;
    return d.innerHTML;
  }

  function sizedImg(url, width) {
    if (!url) return '';
    var full = url.indexOf('//') === 0 ? 'https:' + url : url;
    return full + (full.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  class ProductTile extends HTMLElement {
    connectedCallback() {
      var h = this.getAttribute('handle');
      if (h) this.load(h);
    }

    async load(handle) {
      try {
        var r = await fetch('/products/' + handle + '.js');
        if (!r.ok) return;
        var p = await r.json();
        this.draw(p);
      } catch (e) { /* fallback <a> stays visible */ }
    }

    draw(p) {
      var img = sizedImg(p.featured_image, 600);

      this.innerHTML =
        '<a href="/products/' + esc(p.handle) + '" class="pt-card">' +
          (img ? '<div class="pt-media">' +
            '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' +
          '</div>' : '') +
          '<div class="pt-info">' +
            (p.vendor ? '<p class="pt-vendor">' + esc(p.vendor) + '</p>' : '') +
            '<p class="pt-title">' + esc(p.title) + '</p>' +
            '<span class="pt-btn">Learn More</span>' +
          '</div>' +
        '</a>';
    }
  }

  customElements.define('product-tile', ProductTile);
})();
